export const environment = {
  production: true,
  //encryptKey: 'HackersSeeIT'
  encryptKey: 'pLTmNZo8VRjODHN1CXP3izIxSFCbwb4VjEXRblDlENM=',
  transportCalendarRefreshRate: 120000, // should be in milliseconds (reference scale 1000 ms = 1 s,60000 ms = 1min)
  errorDuration: 3600000, // // should be in milliseconds (reference scale 1000 ms = 1 s,60000 ms = 1min, 3600000 ms = 1hr)
  recaptchaSiteKey: '6LdkVNQZAAAAAHQon19_thXipSzuYVZo5J4xN8s3',
  recaptchaSecretKey: '6LdkVNQZAAAAAAOhYcEdkOe7b7QK7PFy2UAxs55Y'
};